/** `/$org/apps/contract-intelligence/templates`: the standards documents are checked against. */
import { createFileRoute } from "@tanstack/react-router";

import { CiTemplatesPage } from "../components/apps/contractIntelligence/CiTemplatesPage";

export const Route = createFileRoute("/$org/apps/contract-intelligence/templates")({
  component: CiTemplatesPage,
});
